<template>
  <i class="fa fa-download fa-success" @click="downloadAttachment()"/>
</template>

<script>
import { saveAs } from 'file-saver';
import Services from '@/services/index';

const InvoiceService = Services.invoices;
export default {
  mounted() {},
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
    };
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    downloadAttachment() {
      const mimeType = this.data.mime_type;
      InvoiceService.fileFetcher(this.data.url, mimeType).then(({ data }) => {
        const blob = new Blob([data], {
          type: mimeType,
        });
        saveAs(blob, this.data.name);
      });
    }
  }
};

</script>

<style scoped>
</style>
